// src/components/form/CustomForm.jsx
import * as React from 'react';
import { SchedulerForm } from '@progress/kendo-react-scheduler';
import { Dialog } from '@progress/kendo-react-dialogs';
import { CustomFormEditor } from './../CustomFormEditor';

const CustomFormDialog = (props) => {
  console.log('CustomFormDialog rendered with props:', props);
  return <Dialog {...props} title="Event" />;
};

export const FormWithCustomDialog = (props) => {
  const { dataItem, fields, resources, onSubmit: schedulerOnSubmit, onCancel } = props;

  console.log('FormWithCustomDialog Props:', props);

  const handleSubmit = (eventData) => {
    console.log('DEBUG FormWithCustomDialog -> onSubmit called with:', JSON.stringify(eventData, null, 2));
    // Direkte Weitergabe der updated-Daten an den Scheduler
    schedulerOnSubmit(eventData);
  };

  const handleCancel = () => {
    console.log('DEBUG FormWithCustomDialog -> onCancel called');
    onCancel();
  };

  return (
    <SchedulerForm
      {...props}
      editor={(editorProps) => (
        <CustomFormEditor
          {...editorProps}
          dataItem={dataItem}
          fields={fields}
          resources={resources}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      )}
      dialog={CustomFormDialog}
    />
  );
};

export default FormWithCustomDialog;
